import React, { useState } from "react";
import { FormControl, FormLabel, Text } from "@chakra-ui/react";
import { DropdownProps } from "../../utils/types/props.dropdown";
import { color } from "../../utils/theme";
import Select from "react-select";
const Dropdown = ({
  value,
  isRequired,
  onChange,
  options,
  placeholder,
  label,
  style,
  errorMessage,
}: DropdownProps) => {
  return (
    <FormControl style={style ? style : { width: "100%" }}>
      {label && (
        <FormLabel
          display={"flex"}
          mb={0}
          fontWeight={"500"}
          color={color.text}
        >
          {label}{" "}
          {isRequired && (
            <Text color={"red"} mx={1} fontSize={24}>
              *
            </Text>
          )}
        </FormLabel>
      )}
      <Select
        isSearchable={true}
        placeholder={placeholder}
        options={options}
        onChange={(e) => onChange}
      />
      {/* <Select height={"43px"} borderWidth={1} borderColor={errorMessage? "red" :"gray.200"} placeholder={placeholder} value={value} onChange={handleChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select> */}
      <Text marginY={3} fontWeight={"normal"} color={"red"} fontSize={13}>
        {errorMessage}
      </Text>
    </FormControl>
  );
};

export default Dropdown;
